// Ported from platform-legacy/readonly/platform/components/DesignSystemSummaryMinimal.js
// v3 → v3.14: extend → extends. Extends DesignSystemSummary (also ported in
// this folder — load order matters; the barrel registers both).
export const DesignSystemSummaryMinimal = {
  extends: 'DesignSystemSummary',
  Title: {
    text: '{{ editor.ds.title | polyglot }}',
    gap: 'Z',
    margin: '0',
    color: 'caption'
  },
  Box: {
    width: '100%',
    flexFlow: 'row wrap',
    gap: 'Z',
    childExtends: 'SummaryComponent',
    childProps: {
      style: {
        width: '100%'
      },
      margin: '0',
      flex: '0 1 47%',
      DesignComponentProperties: null
    }
  }
}
